import React from 'react';
import Header from '../../../../components/Header';

export default () => {
    return <Header noSecondaryNav />;
};
